export const OPEN_CHAT_ROOM_FETCH_CHATS: string = 'open_chat_room_fetch_chats'
export const POST_CHAT: string = 'post_chat'
export const ADD_AI_CONCIERGE_CHAT: string = 'add_ai_concierge_chat'
export const SET_TYPING_ANIMATION_COMPLETE: string =
  'set_typing_animation_complete'
export const START_NEW_THREAD: string = 'start_new_thread'
export const ADD_ANY_NEW_CHATS: string = 'add_any_new_chats'
